import { useContext } from 'react';
import * as React from 'react';
import { Spinner } from 'react-bootstrap';
import { DebouncedSearch } from '../../../ui/DebouncedSearch/DebouncedSearch';
import { Pagination } from '../../../ui/Pagination/Pagination';
import classNames from './VideoLibraryContainer.module.scss';
import { Videos } from './Videos/Videos';
import { VideosContext, useRefetchVideo } from './VideosProvider/VideosProvider';

const PAGE_SIZE = 10;

export function VideoLibraryContainer() {
  const {
    currentPage,
    setCurrentPage,
    totalCount,

    videos,
    isLoading,

    handleSearchSubmit,
    searchTerm,

    currentPageSize,
  } = useContext(VideosContext);

  const refetchVideo = useRefetchVideo();

  const handleVideosOnChange = () => {
    const lastPage = Math.ceil(videos.length / PAGE_SIZE);
    if (lastPage < currentPage) {
      setCurrentPage(lastPage);
    }
    refetchVideo();
  };

  return (
    <>
      {isLoading && (
        <Spinner
          className={classNames.spinner}
          variant="primary"
          animation="border"
          size="lg"
        />
      )}
      <DebouncedSearch
        initialValue={searchTerm}
        onSearchSubmit={handleSearchSubmit}
      />
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={currentPageSize}
        onPageChange={setCurrentPage}
      />
      <Videos
        videos={videos}
        onChange={handleVideosOnChange}
      />
    </>
  );
}
